<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h3 class="text-dark">
                    <i class="el-icon-time"></i>
                    <span>Schedule</span>
                </h3>

                <el-form-item prop="operating_hours">
                    <div class="form-label">
                        <small>
                            This setting sets the working hours for
                            this agent. Note that the times are
                            local to <b>your company</b> timezone, currently set
                            to
                            <b v-if="current_company">{{ current_company.timezone }}</b>
                        </small>
                    </div>
                    <business-hours
                        v-if="operating_hours_fixed && bot.operating_hours"
                        type="select"
                        color="#00BF50"
                        :days="bot.operating_hours"
                        :time-increment="time_increment">
                    </business-hours>
                </el-form-item>

                <el-form-item class="no-border">
                    <el-checkbox name="process-holidays"
                                class="w-full checkbox-label-description mt-2"
                                v-model="bot.process_on_holidays"
                                border>
                        <label class="mb-1">
                            <span class="mr-1">Work on US national holidays</span>
                        </label>
                        <small>
                            Enabling this will allow this agent to work during (US) holidays.
                        </small>
                    </el-checkbox>
                </el-form-item>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ScheduleTab',
    props: {
        bot: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            time_increment: 30,
            is_fixing_operating_hours: false,
            operating_hours_fixed: false
        }
    },
    computed: {
        ...mapState('cache', ['current_company'])
    },

    methods: {
        fixOperatingHours() {
            if (this.is_fixing_operating_hours) return
            if (!this.bot.operating_hours) return
            
            this.is_fixing_operating_hours = true

            try {
                for (let day of ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']) {
                    if (!this.bot.operating_hours[day]) continue
                    
                    for (let item in this.bot.operating_hours[day]) {
                        // Convert null/undefined/falsy values to empty string
                        if (!this.bot.operating_hours[day][item].open) {
                            this.bot.operating_hours[day][item].open = ''
                        }

                        if (!this.bot.operating_hours[day][item].close) {
                            this.bot.operating_hours[day][item].close = ''
                        }

                        // If open all day (isOpen = true), set both to 24hrs
                        if (this.bot.operating_hours[day][item].isOpen) {
                            if (this.bot.operating_hours[day][item].open === '') {
                                this.bot.operating_hours[day][item].open = '24hrs'
                            }

                            if (this.bot.operating_hours[day][item].close === '') {
                                this.bot.operating_hours[day][item].close = '24hrs'
                            }

                            if (this.bot.operating_hours[day][item].open !== '24hrs' && this.bot.operating_hours[day][item].close === '24hrs') {
                                this.bot.operating_hours[day][item].open = '24hrs'
                            }
                        }
                    }
                }

                this.bot.operating_hours = {
                    monday: this.bot.operating_hours.monday,
                    tuesday: this.bot.operating_hours.tuesday,
                    wednesday: this.bot.operating_hours.wednesday,
                    thursday: this.bot.operating_hours.thursday,
                    friday: this.bot.operating_hours.friday,
                    saturday: this.bot.operating_hours.saturday,
                    sunday: this.bot.operating_hours.sunday,
                }

                this.operating_hours_fixed = true
            } finally {
                this.is_fixing_operating_hours = false
            }
        }
    },

    watch: {
        'bot.id': {
            handler(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.operating_hours_fixed = false
                    this.$nextTick(() => {
                        this.fixOperatingHours()
                    })
                }
            }
        }
    },

    mounted() {
        this.fixOperatingHours()
    }
}
</script>
